<template>
  <div>
    <el-table :data="expressOrderDetails" border style="width: 100%" size="mini">
      <el-table-column prop="goodsName" label="物品名称" width="180" align="center" />
      <el-table-column prop="goods" label="物品分类" width="180" align="center" />
      <el-table-column prop="goodsWeight" label="重量" align="center" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.goodsWeight }}kg</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="件数" align="center" width="100" />
      <el-table-column prop="img" label="物品照片" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.img" class="flex-center">
            <div v-for="item in row.img.split(',')" :key="item" class="margin-right-10">
              <el-image
                style="width: 50px; height: 50px"
                :src="item"
                :preview-src-list="row.img.split(',')"
              />
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  expressOrderDetails: {
    type: Array,
    default: () => []
  }
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
